import { PageType } from '../gamecloud/interface';

export namespace App {
    export class AppModule {
        protected foobar;
        protected components : {new();}[];
        private cachedComponents = new Map<string, any>();
        private static initializedModules = new Map<string, object>();
        
        public static isInitialized(moduleName : string) : boolean {
            return AppModule.initializedModules.has(moduleName);
        }
        
        public getComponent<T>(type: (new () => T)) : T {
            for(let [key, value] of this.cachedComponents) {
                if(key === type.name) {
                    return value;
                }
            }
            
            const newType : T = new type();
            
            this.cachedComponents.set(type.name, newType);
            
            return newType;
        }
        
        constructor() {
            console.debug(`initialized app-module '${this.constructor.name}'`);
            
            AppModule.initializedModules.set(this.constructor.name, this);
            
            // if(this.components && this.components.length) {
            //     this.components.forEach((component, number) => {
            //
            //     });
            // }
        }
    }
    
    export abstract class AuthComponent {
        static isLoggedIn() : boolean {
            return window.login_user !== null;
        }
    }
    
    export abstract class AppComponent extends AuthComponent {
        static getPageType() : PageType {
            return window.pageType;
        }
        
        static getGameKey() : string {
            return $('body').data('game-key');
        }
    }
}

const _global = (window || global) as any;
_global.app = App.AppModule;
